var searchSuggester = {
	inputPlaceholder: "Search",
	clearSearchTerm: "Clear search term",
	noResults: "No results found",
	allSearchResults: "All search results",
	validationErrors: {
		searchTerm: {
			invalidInput: "Invalid input"
		}
	}
};
var searchSuggesterTranslationsEn = {
	searchSuggester: searchSuggester
};

export { searchSuggesterTranslationsEn as default, searchSuggester };
